// Utils
import lineClamp from '../js/utils/line-clamp';
import '../js/utils/closest';

/**
 * Auto injected components Imports
 * ↓ please keep comments (starting with `// ===`) to keep the auto insertion working
 */
// === Imports ===
import AddToCart from './2-javascript/add-to-cart/add-to-cart';
import Modal from './organisms/modal/modal';
import SiteNavigation from './organisms/site-navigation/site-navigation';
import Advertising from './atoms/advertising/advertising';
import CountrySwitcher from './atoms/country-switcher/country-switcher';
import Breadcrumbs from './molecules/breadcrumbs/breadcrumbs';
import CardArticle from './molecules/card-article/card-article';
import ShopNavbar from './molecules/shop-navbar/shop-navbar';
import Form from './organisms/form/form';
import SearchForm from './organisms/search-header/search-form';
import PageShopFilter from './templates/page-shop/page-shop';
import Gallery from './wp-blocks/gallery/gallery';
import WCFormAddress from './woocommerce/form-address/form-address';
import CurrencySelector from './2-javascript/currency-selector/currency-selector';
import ArticleList from './organisms/article-list/article-list';
import HomeHeader from './organisms/home-header/home-header';

// === Loader Object ===
const COMPONENTS_TO_LOAD = [
	{ view: Modal, name: 'Modal', selector: '[data-modal]' },
	{ view: ArticleList, name: 'ArticleList', selector: '.article-list.has-da' }, // Make sure to load ArticleList before Advertisement
	{ view: Advertising, name: 'Advertising', selector: '[data-advertising]' },
	{ view: CountrySwitcher, name: 'CountrySwitcher', selector: '[data-country-switcher]' },
	{ view: Breadcrumbs, name: 'Breadcrumbs', selector: '[data-breadcrumbs]' },
	{ view: CardArticle, name: 'CardArticle', selector: '[data-card-article]' },
	{ view: ShopNavbar, name: 'ShopNavbar', selector: '[data-shop-navbar]' },
	{ view: Form, name: 'Form', selector: '[data-form]' },
	{ view: SearchForm, name: 'SearchForm', selector: '[data-search-form]' },
	{ view: Gallery, name: 'Gallery', selector: '[data-gallery]' },
	{ view: PageShopFilter, name: 'PageShopFilter', selector: '[data-page-shop-filter]' },
	{ view: WCFormAddress, name: 'WCFormAddress', selector: '[data-wc-form-address]' },
	{ view: SiteNavigation, name: 'SiteNavigation', selector: '[data-site-navigation]' },
	{ view: CurrencySelector, name: 'CurrencySelector', selector: '.has-currency-selector' },
	{ view: AddToCart, name: 'AddToCart', selector: '.add_to_cart_button.ajax_add_to_cart' },
	{ view: HomeHeader, name: 'HomeHeader', selector: '.home-header' },
];

// eslint-disable-next-line prefer-const
let LOADED_COMPONENTS = {};

const LOAD_ONCE_COMPONENTS = [];

// Execute utilities before components loading
lineClamp();

/**
 * Load all the components.
 * All the component are builded using the same interface, so...
 * the .bind method does the magic for everyone.
 */
export function componentsLoader() {
	for (let i = 0; i < COMPONENTS_TO_LOAD.length; i++) {
		const {
			selector, view, name,
		} = COMPONENTS_TO_LOAD[ i ];
		const element = document.querySelectorAll(selector);
		// Only if the DOM element exist
		// we load the view.
		if (element && element.length) {
			for (let j = 0; j < element.length; j++) {
				// Create the view instance
				// and push the view in the loaded view cache object.
				if (name + j in LOADED_COMPONENTS) {
					// eslint-disable-next-line no-continue
					continue;
				}

				let v;
				try {
					// eslint-disable-next-line new-cap
					v = new view(element[ j ], name);
					v.init();
				}
				catch (error) {
					console.error('Could not init view:', name, '⬇️');
					console.error(error);
				}

				LOADED_COMPONENTS[ name + j ] = v;
			}
		}
	}

	// DEBUG: Exposes the loaded views for dev purposes
	window.COMPONENTS = LOADED_COMPONENTS;

	return LOADED_COMPONENTS;
}

export function componentsDestroy() {
	Object.keys(LOADED_COMPONENTS).forEach(
		(key) => {
			const destroy = ! LOAD_ONCE_COMPONENTS.includes(LOADED_COMPONENTS[ key ].name);

			if (destroy) {
				LOADED_COMPONENTS[ key ].destroy();
				delete LOADED_COMPONENTS[ key ];
			}
		}
	);
	// DEBUG: Exposes the loaded views for dev purposes
	// window.COMPONENTS = LOADED_COMPONENTS;
	return LOADED_COMPONENTS;
}
